import { useContext, useState } from 'react';
import { ServiceResponse } from '../../../app/services/shared/interfaces';
import { toast } from 'react-toastify';
import ButtonCancelForm from '../../../components/buttons/ButtonCancelForm';
import ButtonSaveForm from '../../../components/buttons/ButtonSaveForm';
import { AppContext } from '../../../contexts/AppContext';
import useReactConfirmAlert from '../../../hooks/useReactConfirmAlert';
import { HopperDocument } from '../../../app/models/Hopper';
import useHopperDocumentService from '../../../app/services/hooks/useHopperDocumentService';
import GeneralDocumentForm from '../../../components/GeneralDocumentForm';

interface Props {
    onSaved?: () => void;
    onCancel?: () => void;
    onError?: () => void;
    hopperId: number;
    typeDocument: string;
}

const HopperDocumentCreate = ({ onSaved, onCancel, onError, typeDocument, hopperId }: Props) => {
    const { showLoading, hideLoading, changeAnimation } = useContext(AppContext);
    const [hopperDocument, setHopperDocument] = useState<HopperDocument>({
        hopper_id: hopperId,
        document_id: parseInt(typeDocument),
        is_expire_date_indefinite: false
    });
    const [errorFields, setErrorFields] = useState<any>();
    const { fetchingStoreHopperDocument, storeHopperDocument } = useHopperDocumentService();

    const store = () => {
        if (!hopperDocument) return;
        if (showLoading) showLoading('loading', 'Guardando documento...');
        storeHopperDocument(hopperDocument, {
            onSuccess: (response: ServiceResponse) => {
                if (hideLoading) hideLoading();
                useReactConfirmAlert().successAlert({
                    title: 'Éxito',
                    message: response.message
                });
                toast.success(response.message, {
                    autoClose: 2500
                });
                if (onSaved) onSaved();
            },
            onError: (response: ServiceResponse) => {
                if (hideLoading) hideLoading();
                useReactConfirmAlert().errorAlert({
                    title: 'Error',
                    message: response.message
                });
            },
            onFieldError: (errorFields: ServiceResponse) => {
                if (hideLoading) hideLoading();
                setErrorFields(errorFields.data);
            }
        });
    };

    const cancel = () => {
        if (onCancel) onCancel();
    };

    // if (errorGetData !== '') {
    //     return <div>{errorGetData}</div>;
    // }

    return (
        <>
            <div className="row">
                <div className="col-12">
                    <GeneralDocumentForm
                        document={hopperDocument}
                        setDocument={setHopperDocument}
                        errorFields={errorFields}
                    />
                </div>
            </div>
            <hr />
            <div className="row justify-content-end">
                <div className="col-auto">
                    <ButtonCancelForm
                        callbackCancel={cancel}
                        locked={fetchingStoreHopperDocument}
                    />
                </div>
                <div className="col-auto">
                    <ButtonSaveForm callbackSave={store} locked={fetchingStoreHopperDocument} />
                </div>
            </div>
        </>
    );
};

export default HopperDocumentCreate;
